import { EntityModel } from '@/interfaces'
import {
  ALL_ELEMENT_SEO_SETTINGS_QUERY,
  CREATE_ELEMENT_SEO_SETTINGS_MUTATION,
  DELETE_ELEMENT_SEO_SETTINGS_MUTATION,
  FORCE_DELETE_ELEMENT_SEO_SETTINGS_MUTATION,
  SINGLE_ELEMENT_SEO_SETTINGS_QUERY,
  UPDATE_ELEMENT_SEO_SETTINGS_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const elementSeoSettingsModel: EntityModel = {
  name: 'elementSeoSettings',
  namePlural: 'elementSeoSettings',
  uniqueName: 'elementSeoSettings',
  uniqueNamePlural: 'elementSeoSettings',
  path: 'seo/element_seo_settings',
  baseUrl: '/seo/element_seo_settings',
  translationPrefix: 'entities:elementSeoSettings.',
  getDisplayName: (values: any) => {
    return values.metaTitle
  },
  gql: {
    getAll: ALL_ELEMENT_SEO_SETTINGS_QUERY,
    getSingle: SINGLE_ELEMENT_SEO_SETTINGS_QUERY,
    create: CREATE_ELEMENT_SEO_SETTINGS_MUTATION,
    update: UPDATE_ELEMENT_SEO_SETTINGS_MUTATION,
    delete: DELETE_ELEMENT_SEO_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_ELEMENT_SEO_SETTINGS_MUTATION,
  },
  attributes: {
    urlSlug: {
      name: 'urlSlug',
      label: 'entities:elementSeoSettings.attributes.urlSlug.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
        },
      ],
    },
    metaTitle: {
      name: 'metaTitle',
      label: 'entities:elementSeoSettings.attributes.metaTitle.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      maxLength: 70,
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    metaDescription: {
      name: 'metaDescription',
      label: 'entities:elementSeoSettings.attributes.metaDescription.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 160,
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    ogTitle: {
      name: 'ogTitle',
      label: 'entities:elementSeoSettings.attributes.ogTitle.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      maxLength: 35,
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    ogDescription: {
      name: 'ogDescription',
      label: 'entities:elementSeoSettings.attributes.ogDescription.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 155,
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    ogImage: {
      name: 'ogImage',
      label: 'entities:elementSeoSettings.attributes.ogImage.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default elementSeoSettingsModel
